export class ListItem {
  id;
  label;
  value;
  constructor(id, label = "", value = null) {
    this.id = id;
    this.label = label;
    this.value = value;
  }
}
